export const OTA_CALCULATOR_ROUTE = '/revenue-management/ota-calculator';

export const canViewRevenueManagement = (permission: Record<string, any> = {}) =>
  permission.revenueManagement?.view === true;

export const isRevenueManagementMenuVisible = canViewRevenueManagement;

export const isOfficialResultBlocked = (code?: string) =>
  new Set([
    'COMMISSION_CONFIGURATION_REQUIRED',
    'OTA_CONFIGURATION_REQUIRED',
    'PROFILE_CONFIGURATION_REQUIRED',
    'PROMOTION_CONFIGURATION_REQUIRED',
    'RATE_PLAN_REQUIRED',
    'TAX_CONFIGURATION_REQUIRED',
  ]).has(code ?? '');
